import React from 'react';
import { useTranslation } from 'react-i18next';

function EmptyEditor(props) {
  const { t } = useTranslation();

  const pageParams = props.pageParams;
  const button = !!pageParams.button ? pageParams.button : {};

  return (
    <div className="object-lp-container">
      <div className="object-lp-content">
        <div className="object-lp-icon">
          <i className={pageParams.icon}></i>
        </div>
        <div className="object-lp-description">
          <h1 className="title">{t(pageParams.title)}</h1>
          <p>{t(pageParams.description)}</p>
          <div className="object-lp-description">
            <a>
              <button
                disabled={button.disabled}
                onClick={() => !!button.onClick && button.onClick()}
                className="btn btn-sm btn-primary btn-outline"
                type="button">
                <i className="fa fa-plus"></i> {t(button.label)}
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  function navigate() {
    const CommonService = this.props.services.CommonService;
    CommonService.utils.goTo(this.props.button.state);
  }
}

export default EmptyEditor;